import { AbstractControl, ValidatorFn } from '@angular/forms';

export const cardProviderRegexList: { name: string; regex: RegExp; startRegex: RegExp; cardIcon: string }[] = [
  {
    name: 'Mastercard',
    regex: /^5[1-5][0-9]{4}|^(222[1-9]|22[3-9]\\d|2[3-6]\\d{2}|27[0-1]\\d|2720)[0-9]{2}$/,
    startRegex: /^5[1-5][0-9]*|^(222[1-9]|22[3-9]\\d|2[3-6]\\d{2}|27[0-1]\\d|2720)[0-9]*$/,
    cardIcon: 'mastercard',
  },
  {
    name: 'American Express',
    regex: /^3[47][0-9]{4}$/,
    startRegex: /^3[47][0-9]*$/,
    cardIcon: 'amex',
  },
  { name: 'Visa', regex: /^4[0-9]{5}$/, startRegex: /^4[0-9]*$/, cardIcon: 'visa' },
  {
    name: 'Discover',
    regex: /^6[0-9]{5}$/,
    startRegex: /^6[0-9]*$/,
    cardIcon: 'discover',
  },
];

export const cardValidator = (): ValidatorFn => {
  return (control: AbstractControl) => {
    const isCardInputValid = cardProviderRegexList.some((card) => card.regex.test(control.value));
    return isCardInputValid ? undefined : { card: true };
  };
};
